import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslate, useShallowEqualSelector } from '@hooks';
import { fetchPopupFeeds, readNotification } from '@actions';
import { PopupFeed } from '@dotone/react-ui-core';

const PopupAnnouncement = ({ shouldStart = false }) => {
  const { locale } = useTranslate();
  const dispatch = useDispatch();

  const { data, status } = useShallowEqualSelector(({ popupFeedList }) => ({
    ...popupFeedList,
    data: popupFeedList[locale].data,
  }));

  useEffect(() => {
    if (status === null) {
      dispatch(fetchPopupFeeds(locale));
    }
  }, [locale, dispatch, status]);

  const handleRead = useCallback(
    ({ notification }) => {
      if (notification && !notification.isRead) {
        dispatch(readNotification(notification.id));
      }
    },
    [dispatch]
  );

  return (
    !!data.length && <PopupFeed popupFeeds={data} shouldStart={shouldStart} onRead={handleRead} />
  );
};

export default PopupAnnouncement;
